import { APIEndpoints } from '@/@admin/types/constants';
import { VTrackerFormData } from '@/@admin/types/entities';
import { ERROR_MESSAGES } from '@/@cms/types';
import { tracking } from '@/lib/features/tracking';
import { studioApi } from '@/lib/http/axios';
import { BaseService } from './base.service';

/**
 * Service class for VTracker management
 */
export class VTrackerService extends BaseService {
    constructor() {
        super(studioApi);
    }

    async createVTracker(data: VTrackerFormData): Promise<string> {
        try {
            const { data: response } = await this.axiosInstance.post(
                APIEndpoints.CREATE_VTRACKER,
                data,
            );
            if (response.hasError) {
                tracking.errorWithSource(
                    new Error(response.message || 'No vTracker data received from the server'),
                    'studio.VTrackerService.createVTracker',
                );
                throw new Error('No vTracker data received from the server');
            }
            return response.url;
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error';
            tracking.errorWithSource(
                new Error(`Failed to create vTracker: ${errorMessage}`),
                'studio.VTrackerService.createVTracker',
            );
            throw new Error(ERROR_MESSAGES.API_ERROR(`Failed to create vTracker: ${errorMessage}`));
        }
    }
}

export const vtrackerService = new VTrackerService();
